export const ABORT_ERROR = 'AbortError';
export const MISSING_AUTH_HEADER_ERROR_MESSAGE = 'Missing auth header';

export function isAbortedRequestError(error: Error) {
  return error.toString().toLowerCase().includes(ABORT_ERROR.toLowerCase());
}

export function isMissingAuthHeaderError(error: unknown) {
  return String(error).toLowerCase().includes(MISSING_AUTH_HEADER_ERROR_MESSAGE.toLowerCase());
}
